import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import loaderAnimation from '../../assets/animations/loader.json';
import styled, { css } from 'styled-components';

const LoaderDiv = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 1;
  animation: fadeOut 1s 3s;
  background-color: #02283c;
  z-index: 444;

  ${({ overlay }) =>
    !overlay &&
    css`
      display: none;
    `}

  .img-div {
    display: flex;
    width: 20rem;
    @media (max-width: 550px) {
      width: 20rem;
    }
    @media (max-width: 350px) {
      width: 15rem;
    }
  }
  p {
    color: #fff;
    text-align: center;
    font-size: 1.4rem;
    letter-spacing: 0.5rem;
    @media (max-width: 350px) {
      font-size: 1rem;
    }
  }
`;

const Loader = ({ loadTime }) => {
  const [state, setState] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      loaderTime();
    }, 3000);
    setTimeout(() => {
      setState(false);
    }, 4000);
    //eslint-disable-next-line
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loaderAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const loaderTime = () => {
    loadTime(false);
  };

  return (
    <LoaderDiv overlay={state}>
      <div className='img-div'>
        <Lottie options={defaultOptions} />
      </div>
      <p>Loading...</p>
    </LoaderDiv>
  );
};

export default Loader;
